import { Component } from '@angular/core';
import { theme } from '../../../../../data/theme';
import { ApiService } from '../../../../service/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-page-contact-us-two',
    templateUrl: './page-contact-us-two.component.html',
    styleUrls: ['./page-contact-us-two.component.scss'],
})
export class PageContactUsTwoComponent {
    theme = theme;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    numberRegEx = "/\-?\d*\.?\d{1,2}/";
    user = {
        'name' : '',
        "email" : '',
        "phone_no" : '',
        "subject" : '',
        "message" : ''
    }
    detail:any;
    constructor(
        private service : ApiService,
        private toastr: ToastrService,

    ) {
        this.service.getWebsiteDetail().subscribe((res:any) => {
            this.detail = res[0];
        })
    }

    submit(data){
        if(data.valid){
            console.log(data.value)
            this.service.postContactForm(data.value).subscribe((res:any) => {
                console.log(res)
                this.toastr.success("Form Submitted Succesfully!!", "" , {timeOut: 2000});

                data.resetForm();
            })

        }else{
            this.toastr.success("Please Fill Validation.", "danger" , {timeOut: 2000});

        }

    }
}
